var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button-group',_vm._l((_vm.meses),function(m){return _c('b-button',{key:m.id,attrs:{"title":m.nome,"variant":_vm.btnVariant(m.id)},on:{"click":function($event){_vm.btnIndex = m.id - 1}}},[_vm._v(_vm._s(m.red))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }